if (!customElements.get("js-collapse")) {
  class jsCollapseElement extends HTMLElement {
    constructor() {
      super();
    }

    open () {
      this.classList.add("active");
    }

    close () {
      this.classList.remove("active");
    }

    toggle () {
      this.classList.toggle("active");
    }
  }

  customElements.define("js-collapse", jsCollapseElement);

  class jsCollapseToggleElement extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (e) => {
        e.preventDefault();
        console.log("toggle", this.dataset.target);
        const target = document.querySelector(this.dataset.target);
        console.log("target", target);
        target.toggle();
      });
    }
  }

  customElements.define("js-collapse-toggle", jsCollapseToggleElement);
}